import { useMutation, useQueryClient } from "@tanstack/react-query";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateAdminAreas } from "@/lib/query/core/invalidation";

type DeleteAreaResponse = { success: true };

export function useDeleteAreaMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ id }: { id: string }) =>
      apiJsonClient<DeleteAreaResponse>(endpoints.admin.areaById(id), {
        method: "DELETE",
      }),
    onSuccess: async () => {
      await invalidateAdminAreas(queryClient);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
